import { isDsd, getDsdLabel } from './formatDetection';

/** Normalize Hz (96000) or kHz (96) to display kHz integer. */
export function sampleRateToKhz(rate: number | string | null | undefined): number | null {
  if (rate == null || rate === '') return null;
  const n = Number(rate);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n >= 1000 ? Math.round(n / 1000) : Math.round(n);
}

export function readBitDepth(track: {
  bitDepth?: number;
  bit_depth?: number;
  maximum_bit_depth?: number;
  maxBitDepth?: number;
} | null | undefined): number | null {
  const v = track?.bitDepth ?? track?.bit_depth ?? track?.maximum_bit_depth ?? track?.maxBitDepth;
  if (v == null || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function readSampleRate(track: {
  sampleRate?: number;
  sample_rate?: number;
  maximum_sampling_rate?: number;
  maxSampleRate?: number;
} | null | undefined): number | null {
  const v = track?.sampleRate ?? track?.sample_rate ?? track?.maximum_sampling_rate ?? track?.maxSampleRate;
  return sampleRateToKhz(v);
}

/**
 * Control-bar quality label: "24/96", "96kHz", "24-bit", or "".
 */
export function formatPlaybackQualityLabel(
  track: {
    bitDepth?: number;
    bit_depth?: number;
    sampleRate?: number;
    sample_rate?: number;
    maximum_bit_depth?: number;
    maxBitDepth?: number;
    maximum_sampling_rate?: number;
    maxSampleRate?: number;
  } | null | undefined,
): string {
  const bd = readBitDepth(track);
  const khz = readSampleRate(track);
  if (bd && khz) return `${bd}/${khz}`;
  if (khz) return `${khz}kHz`;
  if (bd) return `${bd}-bit`;
  return '';
}

/**
 * Track-row resolution pill — unifies local Hz vs Qobuz kHz in one helper.
 * Returns "DSD64", "24/96", "FLAC", or "".
 */
export function formatTrackRowQualityLabel(
  track: {
    format?: string;
    primary_format?: string;
    bitDepth?: number;
    bit_depth?: number;
    sampleRate?: number;
    sample_rate?: number;
    maximum_bit_depth?: number;
    maxBitDepth?: number;
    maximum_sampling_rate?: number;
    maxSampleRate?: number;
    sample_rate_hz?: number;
  } | null | undefined,
): string {
  if (!track) return '';
  if (isDsd(track)) {
    return getDsdLabel(track) || 'DSD';
  }
  const resolution = formatPlaybackQualityLabel(track);
  const fmt = String(track.format || track.primary_format || '').trim().toUpperCase();
  if (resolution && fmt) return `${fmt} ${resolution}`;
  if (resolution) return resolution;
  return fmt;
}
